import React, {useState} from "react";
import Modal from "react-modal";
import XMultiplierCalculator from "./X_Multiplier_Calculator";
import BurnCalculator from "./bornCalculator";
import APYCalculator from "./ApyCalculator";
import VolumeCalculator from "./VolumeCalculator";
import Web3 from "web3";
import Token from '../../abi/pTGC.json';
import Staking from '../../abi/staking.json';
import {providerURL} from "../../utils";

const WithdrawStakingModal = ({ modalIsOpen, closeModal, volumeDaily, volumeWeekly, volumeMonthly, volumeQuarterly, volumeSemiAnnually, volumeAnnually, ptgcPrice}) => {
  const [activeTab, setActiveTab] = useState('tab1');
  const handleTabClick = (tab) => {setActiveTab(tab);};

  const [burnBalance, setBurnBalance] = useState(0);
  const [stakingBalance, setStakingBalance] = useState(0);
  const [selfBalance, setSelfBalance] = useState(0);
  const [lpBalance, setLPBalance] = useState(0);
  const [staked, setStaked] = useState(0);

  const handleModalOpen = async () => {
    const web3 = new Web3(providerURL());
    const pTGCContract = new web3.eth.Contract(Token.ABI, Token.Contract);
    const stakingContract = new web3.eth.Contract(Staking.ABI, Staking.Contract);

    setBurnBalance(parseInt(await pTGCContract.methods.balanceOf('0x0000000000000000000000000000000000000369').call()) / 10**18);
    setStakingBalance(parseInt(await pTGCContract.methods.balanceOf('0xc71f597a2ac39e47f07102e849d18489c96f39ef').call()) / 10**18);
    setSelfBalance(parseInt(await pTGCContract.methods.balanceOf('0x94534eeee131840b1c0f61847c572228bdfdde93').call()) / 10**18);
    setLPBalance(parseInt(await pTGCContract.methods.balanceOf('0xf5a89a6487d62df5308cdda89c566c5b5ef94c11').call()) / 10**18);
    setStaked(parseInt(await stakingContract.methods.totalStaked().call()) / 10**18);
  };
  return (
  <>
    <Modal isOpen={modalIsOpen} onRequestClose={closeModal} contentLabel="Modal" onAfterOpen={handleModalOpen}>
      <div className="My__Overlay">
        <div className="My__OverlayIn">
          <div className="PTGCSEC popupcenter ">
            <button className="nobg closepopup d-flex align-items-center gap-1" onClick={closeModal}><span className="underline">Close</span> <img src="./images/XCircle.svg" className="img-fluid" /></button>
            <div className="text-center">
              <h2 className="mb-0 mt-2  w-100 good_times goldFont">Calculator</h2>
            </div>
              <div className="row justify-content-center mt-4">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <div className="d-flex justify-content-center ">
                    <ul className="nav nav-pills mb-1 gap-1" id="pills-tab" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button className={`nav-link ${activeTab === 'tab1' ? 'active' : ''}`} onClick={() => handleTabClick('tab1')} id="pills-tab1-tab" type="button" role="tab" aria-controls="pills-tab1" aria-selected={activeTab === 'tab1'}>X Multiplier</button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button className={`nav-link ${activeTab === 'tab2' ? 'active' : ''}`} onClick={() => handleTabClick('tab2')} id="pills-tab2-tab" type="button" role="tab" aria-controls="pills-tab2" aria-selected={activeTab === 'tab2'}>Burn</button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button className={`nav-link ${activeTab === 'tab3' ? 'active' : ''}`} onClick={() => handleTabClick('tab3')} id="pills-tab3-tab" type="button" role="tab" aria-controls="pills-tab3" aria-selected={activeTab === 'tab3'}>Reward</button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button className={`nav-link ${activeTab === 'tab4' ? 'active' : ''}`} onClick={() => handleTabClick('tab4')} id="pills-tab4-tab" type="button" role="tab" aria-controls="pills-tab4" aria-selected={activeTab === 'tab4'}>Volume</button>
                    </li>
                  </ul>
                </div>
                <div className="stakeSec  tab-content" id="pills-tabContent">
                  <div className={`tab-pane fade ${activeTab === 'tab1' ? 'show active' : ''}`} id="pills-tab1" role="tabpanel" aria-labelledby="pills-tab1-tab">
                    <XMultiplierCalculator/>
                  </div>
                  <div className={`tab-pane fade ${activeTab === 'tab2' ? 'show active' : ''}`} id="pills-tab2" role="tabpanel" aria-labelledby="pills-tab2-tab">
                    <BurnCalculator volumeDaily={volumeDaily}/>
                  </div>
                  <div className={`tab-pane fade ${activeTab === 'tab3' ? 'show active' : ''}`} id="pills-tab3" role="tabpanel" aria-labelledby="pills-tab3-tab">
                    <APYCalculator burnBalance={burnBalance} stakingBalance={stakingBalance} selfBalance={selfBalance} lpBalance={lpBalance} staked={staked} ptgcPrice={ptgcPrice}/>
                  </div>
                  <div className={`tab-pane fade ${activeTab === 'tab4' ? 'show active' : ''}`} id="pills-tab4" role="tabpanel" aria-labelledby="pills-tab4-tab">
                    <VolumeCalculator volumeDaily={volumeDaily}/>
                  </div>
                </div>
              </div>
            </div>
         </div>
        </div>
      </div>
    </Modal>
    </>
  );
};

export default WithdrawStakingModal;